import { useEffect, useId, useState } from "react";
import dayjs, { type Dayjs } from "dayjs";
import GenericDateRange from "@/components/dateTime/genericDateRange";
import styles from "@/components/forms/inputs/dateField.module.css";

interface Props {
  mandatory?: boolean;
  label?: string;
  readonly?: boolean;
  name?: string;
  required?: boolean;
  onChange?: (event: any) => void;
  defaultValue?: any;
}

const toPickerValue = (value: any): Dayjs | null => {
  if (!value) return null;
  const parsedValue = dayjs(value);
  return parsedValue.isValid() ? parsedValue : null;
};

export default function DateField(props: Props) {
  const generatedId = useId();
  const inputId = props.name ?? generatedId;
  const [value, setValue] = useState<Dayjs | null>(() =>
    toPickerValue(props.defaultValue),
  );

  useEffect(() => {
    setValue(toPickerValue(props.defaultValue));
  }, [props.defaultValue]);

  const handleChange = (newValue: Dayjs | null) => {
    setValue(newValue);
    props.onChange?.({
      target: {
        id: inputId,
        name: props.name,
        value: newValue ? newValue.format("YYYY-MM-DD") : null,
      },
    });
  };

  return (
    <div className={styles.dateFieldContainer}>
      <label className={styles.dateFieldLabel} htmlFor={inputId}>
        {props.mandatory === true
          ? `${props.label + "\u{002A}"}`
          : props.label}
      </label>
      <GenericDateRange
        selectionMode="single"
        value={value}
        onChange={handleChange}
        disabled={props.readonly}
        textFieldProps={{
          id: inputId,
          name: props.name,
          required: props.required,
        }}
      />
    </div>
  );
}
